import { CustomError, ICustomErrorProps } from '@ms/utilities-error/lib/CustomError';

/**
 * @public
 */
export interface ITimeoutErrorProps extends ICustomErrorProps {
  timeout: number;
}

/**
 * Error to be thrown when an operation times out.
 * @public
 */
export class TimeoutError extends CustomError {
  public readonly timeout: number;

  constructor(props: ITimeoutErrorProps) {
    super({
      message: 'Timeout',
      ...(props as ICustomErrorProps)
    });

    this.timeout = props.timeout;
  }
}
